module.exports = __webpack_public_path__ + "img/step1-fr.a78601e6.webp";